export default __webpack_public_path__ + "static/media/nodatafound.b31d8b48.svg";